export default {
  en: {
    editSalePerson: 'Edit Sales Person',
    salePerson: 'Sales Person',
    firstName: 'First Name',
    lastName: 'Last Name',
    position: 'Position',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    signature: 'Signature',
    updateSalePerson: 'Save Changes',
    cancel: 'Cancel',
    editSalePersonSuccessTitle: 'Success',
    editSalePersonSuccessMessage: 'Edit Sales Person Success.',
    remarkImageSize: '* Image size < 1MB',
    imageSizeOverMessage: 'Image size must be smaller than 1MB'
  },
  th: {
    editSalePerson: 'แก้ไขพนักงานขาย',
    salePerson: 'พนักงานขาย',
    firstName: 'ชื่อ',
    lastName: 'สกุล',
    position: 'ตำแหน่ง',
    phone: 'โทร.',
    mobile: 'มือถือ',
    fax: 'แฟกซ์',
    email: 'อีเมล',
    signature: 'ลายเซ็น',
    updateSalePerson: 'บันทึก',
    cancel: 'ยกเลิก',
    editSalePersonSuccessTitle: 'สำเร็จ',
    editSalePersonSuccessMessage: 'แก้ไขพนักงานขายสำเร็จ',
    remarkImageSize: 'ขนาดรูปภาพ < 1MB',
    imageSizeOverMessage: 'ขนาดรูปภาพต้องไม่เกิน 1MB'
  }
}
